import type { Archive, CameraDetail } from '@/@types/typescript-axios'
import API from '@/js/const/api'
import { getIsoDateStr } from '@/js/utils/date'
import http from '@/js/utils/http'

const ARCHIVE_PLAY_RETRY_INTERVAL_SEC = 5

export type MultiVideoArchive = Archive & CameraDetail

type ArchiveRetry = {
  retryCount: number
  timeoutId: ReturnType<typeof setTimeout>
}

type ArchiveRetryTimeoutId = ReturnType<typeof setTimeout> | null

export function requestArchives(cameraCode: string, date: string, time: string) {
  // 分が00ではない場合エラーとなるので00にフォーマット
  const formattedTime = `${time.split(':')[0]}:00`
  const archivesApi = API.CAMERA_ARCHIVES.replace('{camera_code}', cameraCode)
  const params = {
    start_date: getIsoDateStr(`${date} ${formattedTime}`),
    period: 1,
  }

  // 連続実行された場合に最後のリクエストのみ実行する
  http.cancel(`${archivesApi}_get`)

  return http.get(archivesApi, params)
}

export function mergeArchivesWithCameras(
  archives: Archive[][],
  cameras: CameraDetail[],
  displayDate: string
): MultiVideoArchive[] {
  return archives.map((archiveList, index) => {
    const archive = archiveList.find((item) => item.start_time === displayDate)
    return Object.assign(archive as Archive, cameras[index])
  })
}

export function scheduleArchiveRetry(retry: () => void, archiveRetryCount: number): ArchiveRetry {
  const interval = ARCHIVE_PLAY_RETRY_INTERVAL_SEC * 2 ** archiveRetryCount * 1000
  const timeoutId = setTimeout(retry, interval)

  return {
    retryCount: archiveRetryCount + 1,
    timeoutId,
  }
}

export function cancelArchiveRetry(timeoutId: ArchiveRetryTimeoutId): void {
  if (timeoutId !== null) {
    clearTimeout(timeoutId)
  }
}
